/**
 * FAQ SKU links: enhance one open FAQ row using custom.faq_sku_links map.
 * No work until a details row opens. Exact map keys only.
 */
(function () {
  function escapeRe(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function parseMap(root) {
    var raw = root.getAttribute('data-faq-sku-links');
    if (!raw) return null;
    try {
      var map = JSON.parse(raw);
      if (!map || typeof map !== 'object') return null;
      return map;
    } catch (e) {
      return null;
    }
  }

  function sortedKeys(map) {
    return Object.keys(map).sort(function (a, b) {
      return b.length - a.length;
    });
  }

  function hostPath(root) {
    return (root.getAttribute('data-faq-host-path') || '').replace(/\/$/, '');
  }

  function wrapTextNode(node, map, keys, host) {
    var text = node.nodeValue;
    if (!text || !/[A-Za-z]/.test(text)) return;
    var changed = false;
    var frag = document.createDocumentFragment();
    var remaining = text;

    while (remaining.length) {
      var earliest = -1;
      var hitKey = null;
      var hitLen = 0;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var re = new RegExp('\\b' + escapeRe(key) + '\\b', 'i');
        var m = re.exec(remaining);
        if (m && (earliest < 0 || m.index < earliest)) {
          earliest = m.index;
          hitKey = key;
          hitLen = m[0].length;
        }
      }
      if (earliest < 0 || !hitKey) {
        frag.appendChild(document.createTextNode(remaining));
        break;
      }
      if (earliest > 0) {
        frag.appendChild(document.createTextNode(remaining.slice(0, earliest)));
      }
      var matched = remaining.slice(earliest, earliest + hitLen);
      var entry = map[hitKey] || map[hitKey.toUpperCase()];
      // Case-insensitive key lookup
      if (!entry) {
        var uk = hitKey.toUpperCase();
        for (var k in map) {
          if (k.toUpperCase() === uk) {
            entry = map[k];
            break;
          }
        }
      }
      var href = entry && entry.href;
      var destPath = (href || '').replace(/\/$/, '');
      if (entry && href && destPath !== host) {
        var a = document.createElement('a');
        a.className = 'pdp-faq__sku-link';
        a.href = href;
        a.title = entry.title || entry.dest_sku || matched;
        a.textContent = matched;
        frag.appendChild(a);
        changed = true;
      } else {
        frag.appendChild(document.createTextNode(matched));
      }
      remaining = remaining.slice(earliest + hitLen);
    }

    if (changed) {
      node.parentNode.replaceChild(frag, node);
    }
  }

  function walk(el, map, keys, host) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var parent = nodes[i].parentNode;
      if (!parent) continue;
      var tag = parent.nodeName;
      if (tag === 'A' || tag === 'SCRIPT' || tag === 'STYLE') continue;
      wrapTextNode(nodes[i], map, keys, host);
    }
  }

  function enhanceItem(item, map, keys, host) {
    if (item.getAttribute('data-faq-linked') === '1') return;
    var q = item.querySelector('.pdp-faq__question span');
    var a = item.querySelector('.pdp-faq__answer');
    if (q) walk(q, map, keys, host);
    if (a) walk(a, map, keys, host);
    item.setAttribute('data-faq-linked', '1');
  }

  function bindRoot(root) {
    var map = parseMap(root);
    if (!map) return;
    var keys = sortedKeys(map);
    if (!keys.length) return;
    var host = hostPath(root);
    root.addEventListener('toggle', function (ev) {
      var item = ev.target;
      if (!item || !item.classList || !item.classList.contains('pdp-faq__item')) return;
      if (!item.open) return;
      enhanceItem(item, map, keys, host);
    }, true);
  }

  function init() {
    var roots = document.querySelectorAll('.pdp-faq[data-faq-sku-links]');
    for (var i = 0; i < roots.length; i++) bindRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
